<template>
  <div id="app">
    <nav id="nav">
      <h1 class="site-title">
        <router-link to="/">hugohil</router-link>
      </h1>
      <ul>
        <li v-for="(project, index) in projects" :key="index">
          <router-link v-if="!project.waiting" :key="index" :to="`/project/${project.id}`">{{ project.name }}</router-link>
        </li>
        <li class="more-info">... there is more ! Don't hesitate to reach out to have the full story.</li>
      </ul>
      <div class="down-arrow"></div>
    </nav>
    <main id="main">
      <router-view/>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      projects: require('@/assets/projects.json')
    }
  }
}
</script>

<style src="./styles/reset.css"></style>
<style src="./styles/main.css"></style>
<style lang="scss">
  #app {
    display: grid;
    grid-template-areas: "sidebar content";
    grid-template-columns: 1fr 3fr;
    height: 100vh;
    width: 100vw;
    background-image: linear-gradient(to top, #FFEEDD 0%, #F0FCEF 100%);

    .down-arrow {
      position: absolute;
      bottom: 0;
      right: 1em;
    }

    & > nav {
      display: block;
      grid-area: sidebar;
      min-width: 420px;
      background-color: #F6F6FD;
      border-right: .5em solid #16161D;
      box-sizing: border-box;
      z-index: 10;
      overflow: auto;
      position: relative;

      a {
        text-decoration: none;
      }

      .site-title {
        margin-left: .25em;
      }

      li {
        :before {
          content: '*';
          font-weight: 500;
          margin: 0 .5em;
        }

        margin: 1em .25em;
        line-height: 1.33em;
        font-size: 28px;

        .router-link-active {
          background-color: #FFEEDD;
          font-style: italic;
          font-weight: 500;
        }
      }

      .more-info {
        margin-left: 1em;
        font-size: 18px;
        font-style: italic;
        font-weight: 300;
      }
    }
    & > main {
      display: block;
      grid-area: content;
      width: 100%;
      overflow: auto;
      // background-image: linear-gradient(to top, #FFEEDD 0%, #F0FCEF 100%);
    }
  }

  @media (max-width: 1620px) {
    #app {
      & > nav {
        min-width: 240px;
        li {
          margin-top: 1em;
          font-size: 18px;
        }
        .more-info {
          font-size: 16px;
        }
      }
    }
  }

  @media (max-width: 960px) {
    #app {
      grid-template-areas:
        "sidebar"
        "content";
      grid-template-columns: 1fr;

      & > nav {
        border-right: none;
        border-bottom: .5em solid #16161D;
        max-height: 10em;
        overflow: scroll;
        padding-right: 2em;

        .down-arrow:after {
          content: '↓';
        }

        ul {
          margin: 0 .5em;
          li {
            :before {
              content: '***';
            }
            display: inline;
            font-size: 14px;
          }
          .more-info {
            margin-left: 0;
            display: block;
            font-size: 13px;
          }
        }
      }
    }
  }

</style>
